import axios from "axios";
import { useQuery } from "react-query";

const useGetAuthUser = () => {
  const { data, isLoading, error, refetch } = useQuery(
    ["authuser"],
    async () => {
      return await axios.get("auth/logged_user", {
        withCredentials: true,
      });
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes
      refetchOnMount: 'always', // Always refetch on mount, but staleTime prevents if data is fresh
      refetchOnWindowFocus: false, // Don't refetch when window gains focus
      retry: (failureCount, error) =>
        error?.response?.status !== 401 && failureCount < 1,
      onError: (error) => {
        console.error('Error fetching auth user data:', error);
      },
    }
  );

  return { data, isLoading, error, refetch };
};

export default useGetAuthUser;


